/*
 * @Description: 运力管理（司机、车辆、车队）
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-11-14 15:44:51
 * @LastEditors: WangYuhan
 */

import { get, post, put, prefix, deleted } from './base';

// 查询司机列表
export function getDriverList(params) {
  return post(`${prefix}driver/v3/list`, params);
}

// 模糊查询司机列表
export function getDriverListFuzzy(params) {
  return get(`${prefix}driver`, params);
}

// 根据手机号查询司机是否创建
export function createDriver(params) {
  return get(`${prefix}driver/v3/existsMobile`, params);
}

// 创建自有司机
export function createDriverByOwn(params) {
  return post(`${prefix}driver/v3/createOwn`, params);
}

// 司机详情
export function getDriverDetail(params, driverId) {
  return get(`${prefix}driver/v3/${driverId}`, params);
}

// 司机详情
export function getDriverDetailByMobile(params) {
  return get(`${prefix}driver/filter`, params);
}

// 切换自有车/外调司机
export function updateOwnerDriver(params) {
  return post(`${prefix}driver/v3/updateOwn`, params);
}

// 编辑外调司机
export function saveToDriver(params) {
  return post(`${prefix}driver/saveToDriver`, params);
}

// 编辑自有司机
export function updateOwnDriver(params) {
  return post(`${prefix}driver/v3/updateOwn`, params);
}

// 删除司机
export function deleteDriverById(params, driverId) {
  return deleted(`${prefix}driver/${driverId}`, params);
}

// 获取车队信息（分页）
export function getConvoyListByPage(params) {
  return post(`${prefix}convoy/page`, params);
}

// 获取车队信息
export function getConvoyListAll(params) {
  return get(`${prefix}convoy/all`, params);
}

// 根据id获取车队信息
export function getConvoyById(params) {
  return get(`${prefix}convoy`, params);
}

// 创建车队
export function createConvoy(params) {
  return post(`${prefix}convoy`, params);
}

// 更新车队
export function updateConvoy(params) {
  return put(`${prefix}convoy`, params);
}

// 删除车队
export function convoyDelete(params) {
  return deleted(`${prefix}convoy?id=${params}`);
}

// 车队司机数量信息
export function getConvoyInfo(params) {
  return get(`${prefix}convoy/all/info`, params);
}

// 查询车队二维码
export function getConvoyQrCode(params) {
  return get(`${prefix}convoy/convoyQrCode`, params);
}

// 变更车队
export function changeConvoy(params) {
  return put(`${prefix}convoy/changeConvoy`, params);
}

// 司机从车队移除
export function removeConvoy(params) {
  return put(`${prefix}convoy/removeConvoy`, params);
}

// 车辆列表
export function getVehicleList(params, targetGroupId) {
  if (targetGroupId) {
    return post(`${prefix}vehicle/v3/list?targetGroupId=${targetGroupId}`, params);
  } else {
    return post(`${prefix}vehicle/v3/list`, params);
  }
}

// 车辆删除
export function deleteVehicle(params) {
  return get(`${prefix}vehicle/delete`, params);
}

// 车辆详情
export function getVehicleById(params) {
  return get(`${prefix}vehicle/v3/infoByinput`, params);
}

// 车辆详情
export function getVehicleByVehicleNo(params) {
  return get(`${prefix}vehicle/detailByVehicleNo`, params);
}

// 车牌号是否存在
export function exsitsVehicle(params) {
  return post(`${prefix}vehicle/v3/exsitsVehicle`, params);
}

// 编辑车辆
export function updateVehicle(params, targetGroupId) {
  if (targetGroupId) {
    return post(`${prefix}vehicle/update?targetGroupId=${targetGroupId}`, params);
  } else {
    return post(`${prefix}vehicle/update`, params);
  }
}

// 创建外调车
export function createVehicle(params) {
  return post(`${prefix}vehicle/create`, params);
}

// 通过车牌号获取ETC
export function vehicleEtcInfo(params) {
  return get(`${prefix}vehicle/vehicleEtcInfo`, params);
}

// 创建自有车
export function createVehicleOwn(params) {
  return post(`${prefix}vehicle/createOwn`, params);
}

// 编辑自有车
export function updateVehicleOwn(params) {
  return post(`${prefix}vehicle/updateOwn`, params);
}

// 绑定车辆
export function bindVehicle(params) {
  return post(`${prefix}driver/bindVehicle`, params);
}

// 经纪人列表
export function pageCollectInfo(params) {
  return get(`${prefix}collect/pageCollectInfo`, params);
}

// 自有钱包
export function oilTranDetail(params) {
  return get(`${prefix}oil/oilTranDetail`, params);
}

// 获取司机有可用长期余额的企业列表
export function availableBusinessOfXsForPc(params) {
  return get(`${prefix}oil/availableBusinessOfXsForPc`, params);
}

// 长期油款回收
export function oilRecycle(params) {
  return post(`${prefix}oil/oilRecycle`, params);
}

// 油款交易导出
export const oilDetailExport = `${prefix}oil/exportTranDetail`;

// 获取车辆实时位置
export function realPosition(params) {
  return get(`${prefix}vehicle/realPosition`, params);
}

// 导出运单模板
export const uploadEtcHistory = `${prefix}own/waybill/uploadEtcHistory`;

// 根据id查询详情
export function getById(data) {
  return get(`${prefix}vehicle/affiliation/getById`, data);
}

// 分页查询
export function pageList(params) {
  return post(`${prefix}vehicle/affiliation/pageList`, params);
}

// 保存或者编辑
export function saveAndUpdate(params) {
  return post(`${prefix}vehicle/affiliation/saveAndUpdate`, params);
}

// 根据车牌查询挂靠关系
export function getProjectListByBid(params) {
  return get(`${prefix}vehicle/affiliation/getByVehicleNo`, params);
}

// 查询已绑定车辆列表
export function driverBindList(params) {
  return get(`${prefix}driver/bind/list`, params);
}

// 绑定车辆
export function driverBindCar(params) {
  return post(`${prefix}driver/bind/add`, params);
}

// 解绑车辆
export function unBindCar(params) {
  return post(`${prefix}driver/bind/delete`, params);
}

// 设置默认车辆
export function setDefaultCar(params) {
  return post(`${prefix}driver/bind/default`, params);
}

//司机校验信息列表
export function driverListValidate(driverId, params) {
  return get(`${prefix}driver/listValidate/${driverId}`, params);
}

//校验车辆信息
export function vehicleListValidate(vehicleInfoId, params) {
  return get(`${prefix}vehicle/listValidate/${vehicleInfoId}`, params);
}

// 获取运单司机信息
export function getWaybillDriver(params) {
  return get(`${prefix}waybill/v2/getWaybillDriver`, params);
}

// 获取运单车辆信息
export function getWaybillVehicle(params) {
  return get(`${prefix}waybill/v2/getWaybillVehicle`, params);
}

// 人&车&合照绑定
export function postBindDriverVehiclePicture(params) {
  return post(`${prefix}driver/update/bind/driverVehiclePicture`, params);
}
